import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Paper, Alert, CircularProgress } from '@mui/material';
import { submitFeedback } from '../services/api';

const Feedback: React.FC = () => {
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await submitFeedback({
        email,
        message,
        created_at: new Date().toISOString()
      });
      
      setSuccess(true);
      setMessage('');
      setEmail('');
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to submit feedback. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxWidth={500} mx="auto" mt={6}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          Feature Request & Review
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          Let us know what features you want or leave a review!
        </Typography>
        
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        
        {success && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Thank you for your feedback!
          </Alert>
        )}
        
        <form onSubmit={handleSubmit}>
          <TextField
            label="Your Email (optional)"
            fullWidth
            margin="normal"
            value={email}
            onChange={e => setEmail(e.target.value)}
            type="email"
            disabled={loading}
          />
          <TextField
            label="Your Message"
            fullWidth
            required
            multiline
            minRows={4}
            margin="normal"
            value={message}
            onChange={e => setMessage(e.target.value)}
            disabled={loading}
          />
          <Button 
            type="submit" 
            variant="contained" 
            color="primary" 
            fullWidth 
            sx={{ mt: 2 }}
            disabled={loading || !message.trim()}
          >
            {loading ? (
              <>
                <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                Submitting...
              </>
            ) : (
              'Submit'
            )}
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default Feedback; 